// User ID user_Q41bk5XXuqqoGOWwUT5Yk
// Access Token b9025fae74c3e6df50148e1fbcf66946

export const EMAILJS = Object.freeze({
  USER_ID: `user_Q41bk5XXuqqoGOWwUT5Yk`, //userID
  SERVICE_ID: "service_reyqngf",
  TOKEN: `b9025fae74c3e6df50148e1fbcf66946`, // token
  TEMPLATE_ID: `template_lchqmlm`, //templateID
});
